import { Navigate, useNavigate } from 'react-router';

import { Button } from '@llura/ui';

import { useSession } from '../../lib/auth-client';
import { useStrings } from '../../hooks/useStrings';
import { GlowLogo } from '../../shared/glow-logo';

// Shown once right after email verification (the verify link's callbackURL and
// the polling verify-email page both land here). A warm hand-off before the
// first coach session — deliberately a single forward action, no branching.
export function WelcomePage() {
  const navigate = useNavigate();
  const { strings } = useStrings();
  const t = strings.auth.welcome;
  const session = useSession();

  // Only reachable with a session. A signed-out hit (deep link, back button
  // after sign-out) falls through to the root switch.
  if (!session.isPending && !session.data) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="relative min-h-[100svh] overflow-hidden bg-background">
      <div
        aria-hidden
        className="pointer-events-none absolute -top-32 right-[-15%] h-[420px] w-[420px] rounded-full bg-primary/10 blur-3xl"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute bottom-[-10%] left-[-10%] h-[380px] w-[380px] rounded-full bg-secondary/10 blur-3xl"
      />

      <header className="sticky top-0 z-10 flex items-center gap-2 bg-background/80 px-4 py-3 backdrop-blur">
        <span className="font-serif text-lg">{strings.brand.name}</span>
      </header>

      <main className="relative mx-auto flex w-full max-w-md flex-col items-center px-5 pb-16 pt-16 text-center">
        <GlowLogo size={120} />
        <h1 className="mt-8 font-serif text-3xl">{t.title}</h1>
        <p className="mt-3 text-sm text-muted-foreground">{t.body}</p>

        <Button
          className="mt-10 w-full"
          onClick={() => navigate('/onboarding/chat', { replace: true })}
        >
          {t.continueCta}
        </Button>
      </main>
    </div>
  );
}
